import { useMutation } from '@tanstack/react-query';
import { ResendVerificationCodeRequest } from '@/types/request/ResendVerificationCodeRequest';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import BackendClient from '@/api/backendClient.ts';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const useResendVerificationCode = () => {
  const mutationFn = async (request: ResendVerificationCodeRequest) => {
    return resendCode(request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useResendVerificationCode;

async function resendCode(request: ResendVerificationCodeRequest): Promise<{ message: string }> {
  try {
    const response = await BackendClient.post<BackendSuccessResponse<{ message: string }>>(
      '/api/auth/resend-otp',
      request
    );

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while resending verify email code..');
  }
}
